import { useEffect, useState } from "react";
import { card } from "../../types/types";

import { makeGETRequest } from "../../request/rawRequest";
import "../IonColor/color.css";
import Card from "./Card";
import "./CardsFeed.css";

interface ContainerProps {
  state: string;
  endpoint: string;
}

const Cards: React.FC<ContainerProps> = ({ state, endpoint }) => {
  const params = new URLSearchParams(window.location.search);

  const [userEmail, setUserEmail] = useState<string>();

  const [cardsRequest, setCardsRequest] = useState<card[]>([]);

  useEffect(() => {
    makeGETRequest("/me").then((response) => {
      setUserEmail(response.email);
    });
  }, []);

  useEffect(() => {
    if (userEmail && userEmail.length > 2) {
      makeGETRequest("/feed").then((res) => {
        setCardsRequest(
          res.data.reverse().map((post: any) => ({
            username: post.email,
            nameToDisplay: post.first_name + " " + post.last_name,
            image: post.picture_url,
            like: post.likes.length,
            _id: post._id,
            hasLike: post.likes.includes(userEmail),
          }))
        );
      });
    }
  }, [userEmail]);

  return (
    <div>
      {cardsRequest.map((card, i) => (
        <Card
          key={i}
          hasLike={card.hasLike}
          id={card._id}
          displayName={card.nameToDisplay}
          username={card.username ?? "username"}
          title={card.title}
          usernameIcon={card.usernameIcon}
          image={card.image}
          description={card.description}
          like={card.like}
          share={card.share}
          comments={card.comments ?? 0}
          state={state}
        />
      ))}
    </div>
  );
};

export default Cards;
